// extracted by mini-css-extract-plugin
export default {"hd":"TopSectionC_hd__zDSjL","txtop":"TopSectionC_txtop__rC0Eg","hd1":"TopSectionC_hd1__vl1hO"};